import React, { useState, useEffect, useCallback, useMemo } from 'react';
// YENİ EKLENDİ: Yönlendirme için useNavigate hook'u
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Card, Button, Row, Col, Form, ListGroup, Spinner, Alert, Modal } from 'react-bootstrap';
import CreatableSelect from 'react-select/creatable';
import OzelOgunFormu from './OzelOgunFormu';
import api from './api';

function RandevuDetay() {
  const { randevuId } = useParams();
  const navigate = useNavigate();

  // State'ler
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
  const [randevu, setRandevu] = useState(null);
  const [yemekKayitlari, setYemekKayitlari] = useState([]);
  const [sablonlar, setSablonlar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [kategoriListesi, setKategoriListesi] = useState([]);
  const [aramaMetni, setAramaMetni] = useState('');
  const [seciliKategoriId, setSeciliKategoriId] = useState('all');
  const [notlar, setNotlar] = useState([]);
  const [yeniNotFormuGoster, setYeniNotFormuGoster] = useState(false);
  const [duzenlenenNot, setDuzenlenenNot] = useState(null);
  const [profil, setProfil] = useState(null); // Yazdırma başlığındaki logo/diyetisyen adı için
  const [dokumanlar, setDokumanlar] = useState([]);
  const [dokumanYukleniyor, setDokumanYukleniyor] = useState(false);

  // Ölçüm geçmişi
  const [takipGecmisi, setTakipGecmisi] = useState([]);
  const [duzenlenenTakip, setDuzenlenenTakip] = useState(null); // {id, kilo, gogus_cevresi, bel_cevresi, kalca_cevresi, boy}

  // YENİ EKLENDİ: Tablo modülü için gerekli durum değişkenleri
  const [aktifHucre, setAktifHucre] = useState(null);
  const [ekstraOgunler, setEkstraOgunler] = useState([]);
  const [yeniSatirEkleModu, setYeniSatirEkleModu] = useState(false);
  const [kopyaKaynak, setKopyaKaynak] = useState(null); // gün kopyalama: kaynak gün
  const [kopyaHedefler, setKopyaHedefler] = useState([]); // seçili hedef günler
  const [aktifSekme, setAktifSekme] = useState('plan'); // plan | olcum | not | dokuman
  const [ustMenuAcik, setUstMenuAcik] = useState(false);
  const [satirMenu, setSatirMenu] = useState(null); // satır işlemleri menüsü açık olan öğün
  const HAFTANIN_GUNLERI = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'];

  // Ana veri çekme fonksiyonu
  const verileriGetir = useCallback(async () => {
    try {
      const responses = await Promise.all([
        api.get(`/diyetisyen/randevular/${randevuId}`),
        api.get(`/diyetisyen/randevular/${randevuId}/yemekgunlugu`),
        api.get('/diyetisyen/sablon-ogunler'),
        api.get('/diyetisyen/kategoriler'),
        api.get(`/diyetisyen/randevular/${randevuId}/notlar`),
        api.get(`/dokumanlar/randevu/${randevuId}`),
        api.get('/diyetisyen/profil')
      ]);
      setRandevu(responses[0].data);
      setYemekKayitlari(responses[1].data);
      setSablonlar(responses[2].data);
      setKategoriListesi(responses[3].data);
      setNotlar(responses[4].data);
      setDokumanlar(responses[5].data);
      setProfil(responses[6].data);
      // Ölçüm geçmişini çek
      if (responses[0].data?.danisan?.id) {
        const takipRes = await api.get(`/diyetisyen/danisanlar/${responses[0].data.danisan.id}/takip`);
        setTakipGecmisi(takipRes.data);
      }
    } catch (err) {
      setError('Veriler yüklenirken bir hata oluştu.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [randevuId]);

  useEffect(() => { verileriGetir(); }, [verileriGetir]);

  // YENİ EKLENDİ: Randevu silme fonksiyonu
  const handleRandevuSil = async () => {
    if (!window.confirm("Bu randevuyu kalıcı olarak silmek istediğinizden emin misiniz?")) {
      return;
    }
    try {
      await api.delete(`/diyetisyen/randevular/${randevuId}`);
      alert('Randevu başarıyla silindi.');
      // Silme sonrası takvim veya danışan detay sayfasına yönlendirilebilir.
      // Şimdilik en mantıklısı danışanın sayfasına dönmek.
      if (randevu && randevu.danisan) {
        navigate(`/danisan/${randevu.danisan.id}`);
      } else {
        navigate('/randevular'); // Danışan bilgisi yoksa takvime dön
      }
    } catch (err) {
      alert(err.response?.data?.mesaj || "Randevu silinirken bir hata oluştu.");
    }
  };

  const handleGunKopyala = async () => {
    if (!kopyaKaynak || kopyaHedefler.length === 0) return;
    try {
      const res = await api.post(`/diyetisyen/randevular/${randevuId}/yemekgunlugu/gun-kopyala`, {
        kaynak_gun: kopyaKaynak,
        hedef_gunler: kopyaHedefler,
      });
      setKopyaKaynak(null);
      setKopyaHedefler([]);
      await verileriGetir();
      alert(res.data?.mesaj || 'Kopyalandı.');
    } catch (err) {
      alert(err.response?.data?.mesaj || 'Gün kopyalanamadı.');
    }
  };

  const handleSablonEkle = async (sablonId, hedefOgunStr) => {
    try {
      await api.post(`/diyetisyen/randevular/${randevuId}/yemekgunlugu/sablon-ekle`, { sablon_id: sablonId, hedef_ogun: hedefOgunStr });
      setAktifHucre(null);
      verileriGetir();
    } catch (error) { alert(error.response?.data?.mesaj || 'Şablon eklenemedi.'); }
  };

  const handleYemekSil = async (yemekId) => {
    try {
      const danisanId = randevu.danisan.id;
      await api.delete(`/diyetisyen/danisanlar/${danisanId}/yemekgunlugu/${yemekId}`);
      verileriGetir(); 
    } catch (error) {
      alert(error.response?.data?.mesaj || 'Öğün silinemedi.');
    }
  };
  
  const handleKategoriSil = async (ogunAdi) => {
    try {
      await api.delete(`/diyetisyen/randevular/${randevuId}/yemekgunlugu/kategori-sil`, {
        data: { ogun_adi: ogunAdi }
      });
      verileriGetir();
    } catch (error) {
      alert(error.response?.data?.mesaj || 'Kategori silinemedi.');
    }
  };



  const handleUcretToggle = async (e) => {
    const yeniDurum = e.target.checked;
    setRandevu(prev => ({ ...prev, ucret_alindi: yeniDurum }));
    try {
      await api.put(`/diyetisyen/randevular/${randevuId}/ucret-durumu`, {
        ucret_alindi: yeniDurum
      });
    } catch (error) {
      alert("Ücret durumu güncellenirken bir hata oluştu.");
      setRandevu(prev => ({ ...prev, ucret_alindi: !yeniDurum }));
    }
  };

  // --- DOKÜMAN İŞLEMLERİ ---
  const handleDokumanYukle = async (e) => {
    const dosya = e.target.files?.[0];
    e.target.value = ''; // Aynı dosya tekrar seçilebilsin
    if (!dosya) return;
    if (dosya.size > 5 * 1024 * 1024) {
      alert('Dosya en fazla 5 MB olabilir.');
      return;
    }
    const formData = new FormData();
    formData.append('dosya', dosya);
    setDokumanYukleniyor(true);
    try {
      await api.post(`/dokumanlar/randevu/${randevuId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const res = await api.get(`/dokumanlar/randevu/${randevuId}`);
      setDokumanlar(res.data);
    } catch (err) {
      alert(err.response?.data?.mesaj || 'Dosya yüklenemedi.');
    } finally {
      setDokumanYukleniyor(false);
    }
  };

  const handleDokumanIndir = async (dokuman) => {
    try {
      const res = await api.get(`/dokumanlar/${dokuman.id}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = dokuman.orijinal_ad;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert('Dosya indirilemedi.');
    }
  };

  const handleDokumanSil = async (dokumanId) => {
    if (!window.confirm('Bu dosyayı silmek istediğinizden emin misiniz?')) return;
    try {
      await api.delete(`/dokumanlar/${dokumanId}`);
      setDokumanlar(prev => prev.filter(d => d.id !== dokumanId));
    } catch (err) {
      alert(err.response?.data?.mesaj || 'Dosya silinemedi.');
    }
  };

  const boyutFormatla = (bayt) => {
    if (bayt == null) return '';
    if (bayt < 1024) return `${bayt} B`;
    if (bayt < 1024 * 1024) return `${(bayt / 1024).toFixed(0)} KB`;
    return `${(bayt / (1024 * 1024)).toFixed(1)} MB`;
  };

  const handleNotSil = async (notId) => {
    if (!window.confirm('Bu notu silmek istediğinizden emin misiniz?')) return;
    await api.delete(`/diyetisyen/notlar/${notId}`);
    verileriGetir();
  };

  const handleNotSubmit = async (e) => {
    e.preventDefault();
    const icerik = e.target.elements.icerik.value;
    if (!icerik.trim()) return;

    const isUpdating = !!duzenlenenNot?.id;
    const url = isUpdating ? `/diyetisyen/notlar/${duzenlenenNot.id}` : `/diyetisyen/randevular/${randevuId}/notlar`;
    const method = isUpdating ? 'put' : 'post';
    
    try {
      await api[method] (url, { icerik });
      setYeniNotFormuGoster(false);
      setDuzenlenenNot(null);
      verileriGetir();
    } catch (error) {
      alert("İşlem sırasında bir hata oluştu.");
    }
  };

  // YENİ EKLENDİ: Ölçüm Ekleme İşlemi
  const handleTakipSubmit = async (e) => {
    e.preventDefault();
    const kilo = e.target.elements.kilo.value;
    const boy = e.target.elements.boy.value;
    const bel_cevresi = e.target.elements.bel_cevresi.value;
    const kalca_cevresi = e.target.elements.kalca_cevresi.value;
    const gogus_cevresi = e.target.elements.gogus_cevresi.value;

    try {
      await api.post(`/diyetisyen/danisanlar/${randevu.danisan.id}/takip`, {
        kilo: kilo ? parseFloat(kilo) : null,
        boy: boy ? parseFloat(boy) : null,
        bel_cevresi: bel_cevresi ? parseFloat(bel_cevresi) : null,
        kalca_cevresi: kalca_cevresi ? parseFloat(kalca_cevresi) : null,
        gogus_cevresi: gogus_cevresi ? parseFloat(gogus_cevresi) : null,
        randevu_id: parseInt(randevuId)
      });
      alert('Ölçüm başarıyla kaydedildi!');
      e.target.reset();
      verileriGetir();
    } catch (err) {
      alert("Ölçüm eklenirken bir hata oluştu: " + (err.response?.data?.mesaj || 'Bilinmeyen hata'));
    }
  };

  // Ölçüm düzenleme
  const handleTakipGuncelle = async (e) => {
    e.preventDefault();
    if (!duzenlenenTakip) return;
    try {
      await api.put(`/diyetisyen/takip/${duzenlenenTakip.id}`, {
        kilo: duzenlenenTakip.kilo || null,
        boy: duzenlenenTakip.boy || null,
        bel_cevresi: duzenlenenTakip.bel_cevresi || null,
        kalca_cevresi: duzenlenenTakip.kalca_cevresi || null,
        gogus_cevresi: duzenlenenTakip.gogus_cevresi || null,
      });
      setDuzenlenenTakip(null);
      verileriGetir();
    } catch (err) {
      alert("Ölçüm güncellenemedi: " + (err.response?.data?.mesaj || 'Bilinmeyen hata'));
    }
  };

  // Ölçüm silme
  const handleTakipSil = async (takipId) => {
    if (!window.confirm('Bu ölçüm kaydını silmek istediğinizden emin misiniz?')) return;
    try {
      await api.delete(`/diyetisyen/takip/${takipId}`);
      verileriGetir();
    } catch (err) {
      alert("Ölçüm silinemedi: " + (err.response?.data?.mesaj || 'Bilinmeyen hata'));
    }
  };

  // Son ölçüm istatistikleri
  const sonOlcum = takipGecmisi.length > 0 ? takipGecmisi[takipGecmisi.length - 1] : null;

  const filtrelenmisSablonlar = useMemo(() => {
    return sablonlar.filter(sablon => {
      const kategoriMatch = seciliKategoriId === 'all' || (sablon.kategori && sablon.kategori.id == seciliKategoriId);
      const aramaMatch = sablon.ad.toLowerCase().includes(aramaMetni.toLowerCase());
      return kategoriMatch && aramaMatch;
    });
  }, [sablonlar, seciliKategoriId, aramaMetni]);

  const gruplanmisYemekler = useMemo(() => {
    const gruplar = {};
    const gunSiralama = { 'Pazartesi': 1, 'Salı': 2, 'Çarşamba': 3, 'Perşembe': 4, 'Cuma': 5, 'Cumartesi': 6, 'Pazar': 7, 'Her Gün': 8, 'Diğer': 9 };

    yemekKayitlari.forEach(kayit => {
      const ogunRaw = kayit.ogun_adi || 'Diğer';
      let gun = 'Her Gün';
      let ogun = ogunRaw;

      if (ogunRaw.includes('::')) {
        const parts = ogunRaw.split('::');
        gun = parts[0];
        ogun = parts[1];
      }

      if (!gruplar[gun]) { gruplar[gun] = {}; }
      if (!gruplar[gun][ogun]) { gruplar[gun][ogun] = []; }
      
      kayit._display_ogun = ogun;
      gruplar[gun][ogun].push(kayit);
    });

    return gruplar;
  }, [yemekKayitlari]);

  // Tablodaki Satırları (Kategorileri) Belirleme
  const tabloOgunleri = useMemo(() => {
    const ogunSet = new Set();
    yemekKayitlari.forEach(kayit => {
       const ogunRaw = kayit.ogun_adi || 'Diğer';
       const ogun = ogunRaw.includes('::') ? ogunRaw.split('::')[1] : ogunRaw;
       ogunSet.add(ogun);
    });
    if (ogunSet.size === 0) {
       ['Kahvaltı', 'Öğle', 'Akşam'].forEach(o => ogunSet.add(o));
    }
    ekstraOgunler.forEach(o => ogunSet.add(o));
    // Satırları bilinen öğün sırasına göre diz (Kahvaltı → Gece); diğerleri eklendiği sırada sonda
    const SIRA = ['kahvalt', 'ara öğün', 'kuşluk', 'öğle', 'ikindi', 'akşam', 'gece'];
    const siraNo = (ad) => {
      const k = ad.toLocaleLowerCase('tr-TR');
      const i = SIRA.findIndex(x => k.startsWith(x));
      return i === -1 ? SIRA.length : i;
    };
    return Array.from(ogunSet).map((ad, i) => ({ ad, i })).sort((a, b) => (siraNo(a.ad) - siraNo(b.ad)) || (a.i - b.i)).map(x => x.ad);
  }, [yemekKayitlari, ekstraOgunler]);

  const toplamKalori = useMemo(() => 
    yemekKayitlari.reduce((toplam, kayit) => toplam + (kayit.kalori || 0), 0),
  [yemekKayitlari]);

  // Modal kapatma fonskiyonu -> Form submitted trigger onOgunEklendi
  const handleOgunEklendi = () => {
    setAktifHucre(null);
    verileriGetir(); 
  };
  
  if (loading) return <Spinner animation="border" variant='light'/>;
  if (error) return <Alert variant="danger">{error}</Alert>;
  if (!randevu) return <Alert variant="warning">Randevu bulunamadı.</Alert>;

  const tarihObj = new Date(randevu.tarih_saat);
  const bugunGunAdi = HAFTANIN_GUNLERI[(new Date().getDay() + 6) % 7];
  const danisanHarfler = (randevu.danisan.ad_soyad || '').split(' ').map(p => p.charAt(0)).join('').slice(0, 2).toUpperCase();
  const ogunEmoji = (ad) => {
    const k = (ad || '').toLocaleLowerCase('tr-TR');
    if (k.includes('kahvalt')) return '🥣';
    if (k.includes('ara')) return '🍎';
    if (k.includes('öğle') || k.includes('ogle')) return '🥗';
    if (k.includes('akşam') || k.includes('aksam')) return '🍲';
    if (k.includes('gece')) return '🌙';
    return '🍽️';
  };
  const gunToplamlari = HAFTANIN_GUNLERI.map(gun => tabloOgunleri.reduce((acc, ogun) => {
    const kayitlar = gruplanmisYemekler[gun] ? gruplanmisYemekler[gun][ogun] || [] : [];
    return acc + kayitlar.reduce((s, k) => s + (Number(k.kalori) || 0), 0);
  }, 0));
  const enYuksekGun = Math.max(...gunToplamlari, 1);
  // Gün bilgisi olmayan eski kayıtlar ("Her Gün") — tabloda görünmüyordu; ayrı listelenir
  const herGunKayitlari = Object.entries(gruplanmisYemekler)
    .filter(([gun]) => !HAFTANIN_GUNLERI.includes(gun))
    .flatMap(([, ogunler]) => Object.values(ogunler).flat());
  const handleYazdir = () => {
    setAktifSekme('plan');
    setTimeout(() => window.print(), 150);
  };

  return (
    <div>
      {/* --- ÜST BAR: danışan, randevu bilgisi, ücret, yazdır, diğer işlemler --- */}
      <div className="bento-appt-head">
        <Link to={`/danisan/${randevu.danisan.id}`} className="back" title={`${randevu.danisan.ad_soyad} sayfasına geri dön`}>
          <span className="material-symbols-outlined">arrow_back</span>
        </Link>
        <div className="pa">{danisanHarfler}</div>
        <div style={{ minWidth: 0 }}>
          <h2 className="text-truncate">{randevu.danisan.ad_soyad}</h2>
          <div className="meta">
            {tarihObj.toLocaleDateString('tr-TR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })} · {tarihObj.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
            {' '}· Konu: {randevu.konu || '-'}
          </div>
        </div>
        {sonOlcum && (
          <div className="mini ms-lg-3">
            {sonOlcum.kilo != null && <div>Kilo<b>{sonOlcum.kilo} kg</b></div>}
            {sonOlcum.bel_cevresi != null && <div>Bel<b>{sonOlcum.bel_cevresi} cm</b></div>}
            {sonOlcum.vki != null && <div>VKİ<b>{sonOlcum.vki}</b></div>}
          </div>
        )}
        <div className="flex-grow-1" />
        <div className="ucret">
          <Form.Check
            type="switch"
            id="ucret-alindi-switch"
            checked={randevu.ucret_alindi}
            onChange={handleUcretToggle}
          />
          <label htmlFor="ucret-alindi-switch" style={{ cursor: 'pointer' }}>{randevu.ucret_alindi ? 'Ücret alındı' : 'Ücret alınmadı'}</label>
        </div>
        <button type="button" className="bento-pill-btn lime" onClick={handleYazdir}>
          <span className="material-symbols-outlined">print</span>Yazdır / PDF
        </button>
        <div className="bento-dd">
          <button type="button" className="bento-pill-btn ghost" style={{ padding: '10px 12px' }} onClick={() => setUstMenuAcik(v => !v)} title="Diğer işlemler">
            <span className="material-symbols-outlined">more_horiz</span>
          </button>
          {ustMenuAcik && (
            <>
              <div style={{ position: 'fixed', inset: 0, zIndex: 1050 }} onClick={() => setUstMenuAcik(false)} />
              <div className="bento-menu">
                <Link to={`/danisan/${randevu.danisan.id}`}><span className="material-symbols-outlined">person</span>Danışan sayfası</Link>
                <button type="button" className="danger" onClick={() => { setUstMenuAcik(false); handleRandevuSil(); }}>
                  <span className="material-symbols-outlined">delete</span>Randevuyu sil
                </button>
              </div>
            </>
          )}
        </div>
      </div>

      {/* --- SEKMELER --- */}
      <div className="bento-tabs">
        <button type="button" className={aktifSekme === 'plan' ? 'active' : ''} onClick={() => setAktifSekme('plan')}>🍽️ Beslenme planı</button>
        <button type="button" className={aktifSekme === 'olcum' ? 'active' : ''} onClick={() => setAktifSekme('olcum')}>📏 Ölçümler<span className="count">{takipGecmisi.length}</span></button>
        <button type="button" className={aktifSekme === 'not' ? 'active' : ''} onClick={() => setAktifSekme('not')}>📝 Notlar<span className="count">{notlar.length}</span></button>
        <button type="button" className={aktifSekme === 'dokuman' ? 'active' : ''} onClick={() => setAktifSekme('dokuman')}>📎 Dokümanlar<span className="count">{dokumanlar.length}</span></button>
      </div>

      {aktifSekme === 'olcum' && (
        <>
      {/* --- YENİ EKLENDİ: ÖLÇÜM BİLGİLERİ BÖLÜMÜ --- */}
      <Card className="mb-4 glass-card">
        <Card.Body>
           <div className="d-flex align-items-center mb-3">
             <span className="material-symbols-outlined me-2" style={{ color: 'var(--accent-primary)', fontSize: '1.5rem' }}>monitor_weight</span>
             <h4 className="m-0 fw-bold" style={{ color: 'var(--text-main)' }}>Yeni Ölçüm Ekle</h4>
           </div>
           
           <Form onSubmit={handleTakipSubmit}>
             <Row className="g-3">
               <Col md={4} sm={6}>
                 <Form.Group>
                   <Form.Label style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Kilo (kg)</Form.Label>
                   <Form.Control type="number" step="0.1" name="kilo" placeholder="Örn: 70.5" required style={{ backgroundColor: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border-color)' }} />
                 </Form.Group>
               </Col>
               <Col md={4} sm={6}>
                 <Form.Group>
                   <Form.Label style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Göğüs (cm)</Form.Label>
                   <Form.Control type="number" step="0.1" name="gogus_cevresi" placeholder="Örn: 95" style={{ backgroundColor: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border-color)' }} />
                 </Form.Group>
               </Col>
               <Col md={4} sm={6}>
                 <Form.Group>
                   <Form.Label style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Bel (cm)</Form.Label>
                   <Form.Control type="number" step="0.1" name="bel_cevresi" placeholder="Örn: 80" style={{ backgroundColor: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border-color)' }} />
                 </Form.Group>
               </Col>
               <Col md={4} sm={6}>
                 <Form.Group>
                   <Form.Label style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Kalça (cm)</Form.Label>
                   <Form.Control type="number" step="0.1" name="kalca_cevresi" placeholder="Örn: 100" style={{ backgroundColor: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border-color)' }} />
                 </Form.Group>
               </Col>
               <Col md={4} sm={6}>
                 <Form.Group>
                   <Form.Label style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Boy (cm) - VKİ için</Form.Label>
                   <Form.Control type="number" step="0.1" name="boy" placeholder="Örn: 175" style={{ backgroundColor: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border-color)' }} />
                 </Form.Group>
               </Col>
             </Row>
             <div className="mt-3 text-end">
               <Button type="submit" variant="primary" className="fw-bold px-4" style={{ backgroundColor: 'var(--accent-primary)', border: 'none' }}>Kaydet</Button>
             </div>
           </Form>
        </Card.Body>
      </Card>

      {/* --- ÖLÇÜM KARTLARI --- */}
      {sonOlcum && (
        <Row className="g-3 mb-4">
          {[
            { label: 'Kilo', value: sonOlcum.kilo, unit: 'kg', icon: 'monitor_weight', color: '#60a5fa' },
            { label: 'Göğüs', value: sonOlcum.gogus_cevresi, unit: 'cm', icon: 'straighten', color: '#f472b6' },
            { label: 'Bel', value: sonOlcum.bel_cevresi, unit: 'cm', icon: 'straighten', color: '#fbbf24' },
            { label: 'Kalça', value: sonOlcum.kalca_cevresi, unit: 'cm', icon: 'straighten', color: '#34d399' },
            { label: 'VKİ', value: sonOlcum.vki, unit: '', icon: 'analytics', color: '#a78bfa' },
          ].map((item, i) => (
            <Col key={i} xs={6} lg>
              <div className="p-3 rounded-3" style={{ backgroundColor: 'var(--bg-secondary)', border: '1px solid var(--border-color)' }}>
                <div className="d-flex align-items-center gap-2 mb-1">
                  <span className="material-symbols-outlined" style={{ color: item.color, fontSize: '1.1rem' }}>{item.icon}</span>
                  <span style={{ color: 'var(--text-muted)', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{item.label}</span>
                </div>
                <div style={{ fontSize: '1.5rem', fontWeight: '800', color: 'var(--text-main)' }}>
                  {item.value != null ? item.value : '—'}
                  <span style={{ fontSize: '0.75rem', fontWeight: '500', color: 'var(--text-muted)', marginLeft: '2px' }}>{item.value != null ? item.unit : ''}</span>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      )}

      {/* --- ÖLÇÜM GEÇMİŞİ TABLOSU --- */}
      {takipGecmisi.length > 0 && (
        <Card className="mb-4 glass-card">
          <Card.Body>
            <h5 className="fw-bold mb-3" style={{ color: 'var(--text-main)' }}>Ölçüm Geçmişi</h5>
            <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
              <table className="w-100" style={{ borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid var(--border-color)' }}>
                    {['Tarih', 'Kilo', 'Göğüs', 'Bel', 'Kalça', 'VKİ', ''].map((h, i) => (
                      <th key={i} className="pb-2 text-uppercase" style={{ fontSize: '0.7rem', letterSpacing: '0.5px', color: 'var(--text-muted)' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {takipGecmisi.map(t => (
                    <tr key={t.id} className="border-bottom" style={{ borderColor: 'var(--border-color)' }}>
                      <td className="py-2" style={{ color: 'var(--text-main)', fontSize: '0.85rem', fontWeight: '600' }}>{new Date(t.tarih).toLocaleDateString('tr-TR')}</td>
                      <td className="py-2" style={{ color: 'var(--text-main)', fontSize: '0.85rem' }}>{t.kilo || '—'}</td>
                      <td className="py-2" style={{ color: 'var(--text-main)', fontSize: '0.85rem' }}>{t.gogus_cevresi || '—'}</td>
                      <td className="py-2" style={{ color: 'var(--text-main)', fontSize: '0.85rem' }}>{t.bel_cevresi || '—'}</td>
                      <td className="py-2" style={{ color: 'var(--text-main)', fontSize: '0.85rem' }}>{t.kalca_cevresi || '—'}</td>
                      <td className="py-2" style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>{t.vki || '—'}</td>
                      <td className="py-2 text-end">
                        <Button variant="link" size="sm" className="p-0 me-2" onClick={() => setDuzenlenenTakip({ ...t })} style={{ color: 'var(--accent-primary)' }}>
                          <span className="material-symbols-outlined" style={{ fontSize: '1rem' }}>edit</span>
                        </Button>
                        <Button variant="link" size="sm" className="p-0" onClick={() => handleTakipSil(t.id)} style={{ color: '#ef4444' }}>
                          <span className="material-symbols-outlined" style={{ fontSize: '1rem' }}>delete</span>
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Card>
      )}

        </>
      )}

      {/* --- ÖLÇÜM DÜZENLEME MODAL --- */}
      {duzenlenenTakip && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="p-4 rounded-3 shadow-lg" style={{ width: '600px', maxWidth: '95%', backgroundColor: 'var(--bg-secondary)', border: '1px solid var(--border-color)' }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="m-0 fw-bold" style={{ color: 'var(--text-main)' }}>Ölçüm Düzenle</h5>
              <Button variant="link" className="p-0" onClick={() => setDuzenlenenTakip(null)} style={{ color: 'var(--text-muted)' }}>
                <span className="material-symbols-outlined">close</span>
              </Button>
            </div>
            <Form onSubmit={handleTakipGuncelle}>
              <Row className="g-3">
                {[
                  { label: 'Kilo (kg)', key: 'kilo' },
                  { label: 'Göğüs (cm)', key: 'gogus_cevresi' },
                  { label: 'Bel (cm)', key: 'bel_cevresi' },
                  { label: 'Kalça (cm)', key: 'kalca_cevresi' },
                  { label: 'Boy (cm)', key: 'boy' },
                ].map(f => (
                  <Col md={6} key={f.key}>
                    <Form.Group>
                      <Form.Label style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>{f.label}</Form.Label>
                      <Form.Control type="number" step="0.1"
                        value={duzenlenenTakip[f.key] || ''}
                        onChange={e => setDuzenlenenTakip({ ...duzenlenenTakip, [f.key]: e.target.value })}
                        style={{ backgroundColor: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border-color)' }}
                      />
                    </Form.Group>
                  </Col>
                ))}
              </Row>
              <div className="mt-3 d-flex gap-2 justify-content-end">
                <Button variant="secondary" size="sm" onClick={() => setDuzenlenenTakip(null)}>İptal</Button>
                <Button type="submit" size="sm" style={{ backgroundColor: 'var(--accent-primary)', border: 'none' }}>Güncelle</Button>
              </div>
            </Form>
          </div>
        </div>
      )}


      {aktifSekme === 'not' && (
        <div className="bento-tile mb-4">
      {/* --- YENİ NOTLAR BÖLÜMÜ --- */}
       <div className="mb-4">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h4 className="mb-0 fw-bold">Randevu Notları</h4>
          <Button variant={`outline-${theme === 'dark' ? 'light' : 'dark'}`} size="sm" onClick={() => setYeniNotFormuGoster(!yeniNotFormuGoster)}>
            {yeniNotFormuGoster ? 'İptal' : '+ Yeni Not Ekle'}
          </Button>
        </div>

        {yeniNotFormuGoster && !duzenlenenNot && (
          <Card className="glass-card my-2">
            <Card.Body>
              <Form onSubmit={handleNotSubmit}>
                <Form.Group>
                  <Form.Control as="textarea" rows={3} name="icerik" required placeholder="Yeni not..." />
                </Form.Group>
                <div className="text-end mt-2">
                  <Button type="submit" size="sm" variant="primary">Kaydet</Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        )}
        
        <Row>
          {notlar.map(not => (
            <Col md={4} key={not.id} className="mb-2">
              <Card className="glass-card h-100">
                <Card.Body>
                  {duzenlenenNot?.id === not.id ? (
                    <Form onSubmit={handleNotSubmit}>
                      <Form.Group>
                        <Form.Control as="textarea" rows={3} name="icerik" required defaultValue={not.icerik} />
                      </Form.Group>
                      <div className="text-end mt-2">
                        <Button variant="secondary" size="sm" onClick={() => setDuzenlenenNot(null)} className="me-2">İptal</Button>
                        <Button type="submit" size="sm" variant="primary">Güncelle</Button>
                      </div>
                    </Form>
                  ) : (
                    <div className="d-flex flex-column h-100">
                      <Card.Text className="flex-grow-1">{not.icerik}</Card.Text>
                      <div className="d-flex justify-content-between align-items-center mt-2">
                        <small className="text-white-50">{new Date(not.tarih).toLocaleDateString('tr-TR')}</small>
                        <div>
                          <Button variant="outline-warning" size="sm" onClick={() => { setDuzenlenenNot(not); setYeniNotFormuGoster(false); }}>Düzenle</Button>
                          <Button variant="outline-danger" size="sm" className="ms-2" onClick={() => handleNotSil(not.id)}>Sil</Button>
                        </div>
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

        </div>
      )}

      {/* --- DOKÜMANLAR --- */}
      {aktifSekme === 'dokuman' && (
      <Card className="mb-4 glass-card">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
              <span className="material-symbols-outlined me-2" style={{ color: 'var(--accent-primary)', fontSize: '1.5rem' }}>folder_open</span>
              <h4 className="m-0 fw-bold" style={{ color: 'var(--text-main)' }}>Dokümanlar</h4>
            </div>
            <div>
              <input type="file" id="dokuman-input" style={{ display: 'none' }}
                accept=".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx,.xls,.xlsx,.txt,.csv"
                onChange={handleDokumanYukle} />
              <Button variant="outline-success" size="sm" disabled={dokumanYukleniyor}
                onClick={() => document.getElementById('dokuman-input').click()}>
                {dokumanYukleniyor ? <Spinner size="sm" animation="border" /> : '+ Dosya Yükle'}
              </Button>
            </div>
          </div>
          {dokumanlar.length === 0 ? (
            <p className="mb-0" style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
              Henüz doküman eklenmemiş. Tahlil sonucu, diyet listesi gibi dosyaları buraya yükleyebilirsiniz (maks. 5 MB).
            </p>
          ) : (
            <ListGroup variant="flush">
              {dokumanlar.map(d => (
                <ListGroup.Item key={d.id} className="d-flex justify-content-between align-items-center"
                  style={{ backgroundColor: 'transparent', borderColor: 'var(--border-color)' }}>
                  <div className="d-flex align-items-center gap-2" style={{ minWidth: 0 }}>
                    <span className="material-symbols-outlined" style={{ color: 'var(--text-muted)' }}>
                      {d.mime_type?.startsWith('image/') ? 'image' : 'description'}
                    </span>
                    <span style={{ color: 'var(--text-main)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.orijinal_ad}</span>
                    <small style={{ color: 'var(--text-muted)', flexShrink: 0 }}>
                      {boyutFormatla(d.boyut)} · {d.yuklenme_tarihi ? new Date(d.yuklenme_tarihi).toLocaleDateString('tr-TR') : ''}
                    </small>
                  </div>
                  <div className="d-flex gap-2 flex-shrink-0">
                    <Button variant="outline-primary" size="sm" onClick={() => handleDokumanIndir(d)}>İndir</Button>
                    <Button variant="outline-danger" size="sm" onClick={() => handleDokumanSil(d.id)}>Sil</Button>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Card.Body>
      </Card>

      )}

      {/* --- HAFTALIK BESLENME PLANI --- */}
      <div className="plan-board print-section mb-4" style={{ display: aktifSekme === 'plan' ? 'block' : 'none' }}>
        {/* Print-only Header */}
        <div className="print-header" style={{ display: 'none' }}>
          <div className="print-header-ust">
            {profil?.logo_data ? (
              <img src={profil.logo_data} alt="Logo" className="print-logo" />
            ) : (
              <div className="print-logo-bosluk" />
            )}
            <div className="print-header-baslik">
              <h2>Haftalık Beslenme Planı</h2>
              {profil?.kullanici_adi && <p className="print-diyetisyen">Dyt. {profil.kullanici_adi}{profil.klinik_adi ? ` · ${profil.klinik_adi}` : ''}</p>}
            </div>
            <div className="print-logo-bosluk" />
          </div>
          <div className="print-header-bilgi">
            <span><strong>Danışan:</strong> {randevu.danisan.ad_soyad}</span>
            <span><strong>Plan Tarihi:</strong> {new Date(randevu.tarih_saat).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
            {sonOlcum?.kilo && <span><strong>Güncel Kilo:</strong> {sonOlcum.kilo} kg</span>}
            {sonOlcum?.vki && <span><strong>VKİ:</strong> {sonOlcum.vki}</span>}
          </div>
        </div>


        <div className="d-flex justify-content-between align-items-center mb-3 no-print">
          <div>
            <h4 className="m-0 fw-bold">Haftalık Beslenme Planı</h4>
            <p className="mb-0 mt-1" style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>Hücreye tıklayarak besin veya şablon ekleyin · gün başlığındaki ikonla günü kopyalayın</p>
          </div>
          <div className="text-end">
            <div style={{ fontSize: 12, color: 'var(--text-muted)', fontWeight: 600 }}>Haftalık toplam</div>
            <div style={{ fontSize: 22, fontWeight: 800 }}>{toplamKalori.toFixed(0)} <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>kcal</span></div>
          </div>
        </div>

        {herGunKayitlari.length > 0 && (
          <div className="plan-note" style={{ flexWrap: 'wrap' }}>
            <span className="material-symbols-outlined" style={{ fontSize: 18 }}>info</span>
            <span className="fw-bold">Gün belirtilmemiş kayıtlar (Her gün):</span>
            {herGunKayitlari.map(kayit => (
              <span key={kayit.id} className="plan-item" style={{ display: 'inline-block' }}>
                {kayit._display_ogun}: {kayit.yemek_detayi}{kayit.kalori ? ` · ${Number(kayit.kalori).toFixed(0)} kcal` : ''}
                <button type="button" className="del" title="Kaydı sil" onClick={() => handleYemekSil(kayit.id)}>
                  <span className="material-symbols-outlined" style={{ fontSize: 15 }}>delete</span>
                </button>
              </span>
            ))}
          </div>
        )}

        <div className="plan-scroll">
          <div className="plan-grid">
            <div />
            {HAFTANIN_GUNLERI.map(gun => (
              <div key={gun} className={`plan-dh ${gun === bugunGunAdi ? 'today' : ''}`}>
                <span>{gun}</span>
                <button
                  type="button"
                  title={`${gun} gününü başka güne kopyala`}
                  onClick={() => { setKopyaKaynak(gun); setKopyaHedefler([]); }}
                >
                  <span className="material-symbols-outlined" style={{ fontSize: '1rem' }}>content_copy</span>
                </button>
              </div>
            ))}

            {tabloOgunleri.map((ogun, satirIndex) => (
              <React.Fragment key={ogun}>
                <div className="plan-ml">
                  <span className="emoji">{ogunEmoji(ogun)}</span>
                  <span>{ogun}</span>
                  <div className="row-menu">
                    <button type="button" title="Satır işlemleri" onClick={() => setSatirMenu(satirMenu === ogun ? null : ogun)}>
                      <span className="material-symbols-outlined" style={{ fontSize: 18 }}>more_vert</span>
                    </button>
                    {satirMenu === ogun && (
                      <>
                        <div style={{ position: 'fixed', inset: 0, zIndex: 1050 }} onClick={() => setSatirMenu(null)} />
                        <div className="bento-menu">
                          <button type="button" className="danger" onClick={() => {
                            setSatirMenu(null);
                            if (window.confirm(`"${ogun}" satırındaki tüm günlerin kayıtları silinsin mi?`)) handleKategoriSil(ogun);
                          }}>
                            <span className="material-symbols-outlined">delete_sweep</span>Satırı sil
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {HAFTANIN_GUNLERI.map(gun => {
                  const hucreKayitlari = gruplanmisYemekler[gun] ? gruplanmisYemekler[gun][ogun] || [] : [];
                  const hucreKcal = hucreKayitlari.reduce((s, k) => s + (Number(k.kalori) || 0), 0);
                  if (hucreKayitlari.length === 0) {
                    return (
                      <div key={`${gun}-${ogun}`} className="plan-cell empty" onClick={() => setAktifHucre({ gun, ogun })} title={`${gun} - ${ogun} ekle`}>
                        + ekle
                      </div>
                    );
                  }
                  return (
                    <div key={`${gun}-${ogun}`} className={`plan-cell c${satirIndex % 6}`} onClick={() => setAktifHucre({ gun, ogun })} title={`${gun} - ${ogun} ekle`}>
                      {hucreKayitlari.map(kayit => (
                        <div key={kayit.id} className="plan-item meal-item" data-meal-type={kayit.ogun_adi?.toLowerCase()} onClick={e => e.stopPropagation()}>
                          {kayit.yemek_detayi}
                          <button type="button" className="del" title="Kaydı sil" onClick={() => handleYemekSil(kayit.id)}>
                            <span className="material-symbols-outlined" style={{ fontSize: 15 }}>delete</span>
                          </button>
                        </div>
                      ))}
                      <div className="plan-kc">
                        <span>{hucreKcal > 0 ? `${hucreKcal.toFixed(0)} kcal` : ''}</span>
                        <span className="material-symbols-outlined">add</span>
                      </div>
                    </div>
                  );
                })}
              </React.Fragment>
            ))}
          </div>

          <div className="plan-tot">
            <div className="lbl">Günlük toplam</div>
            {gunToplamlari.map((gunToplam, i) => (
              <div key={`toplam-${HAFTANIN_GUNLERI[i]}`} style={{ color: gunToplam > 0 ? 'var(--text-main)' : 'var(--text-muted)' }}>
                {gunToplam > 0 ? `${gunToplam.toFixed(0)} kcal` : '–'}
                <div className="plan-bar"><i style={{ width: `${(gunToplam / enYuksekGun) * 100}%` }} /></div>
              </div>
            ))}
          </div>
        </div>

        <div className="plan-foot">
            <div className="text-start no-print" style={{ minWidth: '320px', maxWidth: '380px' }}>
              {!yeniSatirEkleModu ? (
                <button type="button" className="plan-addrow no-print" onClick={() => setYeniSatirEkleModu(true)}>
                  <span className="material-symbols-outlined" style={{ fontSize: 18 }}>add</span>Yeni öğün satırı ekle
                </button>
              ) : (
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 me-2">
                    <CreatableSelect
                      isClearable
                      isSearchable
                      placeholder="Öğün Ara (Eğer yoksa Enter ile oluştur)..."
                      options={kategoriListesi.map(k => ({ value: k.ad, label: k.ad }))}
                      onChange={(newValue) => {
                        if (newValue && newValue.value) {
                          if (!tabloOgunleri.includes(newValue.value)) {
                            setEkstraOgunler([...ekstraOgunler, newValue.value]);
                          }
                          setYeniSatirEkleModu(false);
                        }
                      }}
                      formatCreateLabel={userInput => `"${userInput}" oluştur`}
                      noOptionsMessage={() => "Seçenek yok"}
                      styles={{
                        control: (base) => ({ ...base, backgroundColor: 'var(--bg-primary)', borderColor: 'var(--border-color)', color: 'var(--text-main)', boxShadow: 'none' }),
                        menu: (base) => ({ ...base, backgroundColor: 'var(--bg-primary)', border: '1px solid var(--border-color)', zIndex: 9999 }),
                        option: (base, state) => ({ ...base, backgroundColor: state.isFocused ? 'var(--bg-secondary)' : 'var(--bg-primary)', color: 'var(--text-main)', cursor: 'pointer' }),
                        singleValue: (base) => ({ ...base, color: 'var(--text-main)' }),
                        input: (base) => ({ ...base, color: 'var(--text-main)' }),
                        placeholder: (base) => ({ ...base, color: 'var(--text-muted)' }),
                        clearIndicator: (base) => ({ ...base, color: 'var(--text-muted)' }),
                        dropdownIndicator: (base) => ({ ...base, color: 'var(--text-muted)' }),
                      }}
                    />
                  </div>
                  <Button variant="outline-danger" size="sm" onClick={() => setYeniSatirEkleModu(false)}>İptal</Button>
                </div>
              )}
            </div>
          <div className="flex-grow-1" />
          {yemekKayitlari.length > 0 && (
            <div className="d-flex align-items-center gap-3 no-print">
              <span className="fw-bold" style={{ fontSize: 15 }}>
                Haftalık Toplam Kalori: <span style={{ color: 'var(--accent-tertiary)' }}>{toplamKalori.toFixed(0)} kcal</span>
              </span>
              <button type="button" className="bento-pill-btn dark" onClick={handleYazdir}>
                <span className="material-symbols-outlined">print</span>Tabloyu yazdır
              </button>
            </div>
          )}
        </div>

            {/* Print-only Kalori & Footer */}
            <div className="print-kalori" style={{ display: 'none' }}>
              Haftalık Toplam Kalori: {toplamKalori.toFixed(0)} kcal
            </div>
            <div className="print-footer" style={{ display: 'none' }}>
              <p>
                {profil?.kullanici_adi ? `Bu beslenme planı Dyt. ${profil.kullanici_adi} tarafından hazırlanmıştır.` : 'Bu beslenme planı Diyet-Takip sistemi aracılığıyla hazırlanmıştır.'}
                {' '}· {new Date().toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}
              </p>
              <p className="print-footer-not">Öğün saatlerinize ve porsiyon miktarlarına dikkat ediniz. Sorularınız için diyetisyeninize danışın.</p>
            </div>
      </div>

      {/* --- MODAL (HÜCREYE TIKLANINCA ÇIKAN FORM) --- */}
      {/* Günü Kopyala modalı */}
      <Modal show={!!kopyaKaynak} onHide={() => setKopyaKaynak(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '1.1rem' }}>
            <span className="material-symbols-outlined align-middle me-2" style={{ fontSize: '1.2rem', color: 'var(--accent-primary)' }}>content_copy</span>
            {kopyaKaynak} gününü kopyala
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted" style={{ fontSize: '0.85rem' }}>
            "{kopyaKaynak}" günündeki tüm öğün ve besinleri seçtiğiniz günlere kopyalar.
            Hedef günde zaten var olan aynı kayıtlar atlanır.
          </p>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="fw-bold">Hedef günler</span>
            <Button variant="link" size="sm" className="p-0 text-decoration-none"
              onClick={() => setKopyaHedefler(HAFTANIN_GUNLERI.filter(g => g !== kopyaKaynak))}>
              Tüm günleri seç
            </Button>
          </div>
          <div className="d-flex flex-wrap gap-2">
            {HAFTANIN_GUNLERI.filter(g => g !== kopyaKaynak).map(g => {
              const secili = kopyaHedefler.includes(g);
              return (
                <button key={g} type="button" className="btn-modern"
                  onClick={() => setKopyaHedefler(secili ? kopyaHedefler.filter(x => x !== g) : [...kopyaHedefler, g])}
                  style={{
                    background: secili ? 'var(--accent-primary)' : 'var(--bg-tertiary)',
                    color: secili ? '#fff' : 'var(--text-main)',
                    borderColor: 'var(--border-color)',
                  }}>
                  {g}
                </button>
              );
            })}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setKopyaKaynak(null)}>İptal</Button>
          <Button variant="primary" disabled={kopyaHedefler.length === 0} onClick={handleGunKopyala}>
            Kopyala ({kopyaHedefler.length})
          </Button>
        </Modal.Footer>
      </Modal>

      {aktifHucre && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="p-4 rounded-3 shadow-lg" style={{ width: '900px', maxWidth: '95%', overflow: 'visible', border: '1px solid var(--border-color)', backgroundColor: 'var(--bg-primary)' }}>
            <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" style={{ borderColor: 'var(--border-color)' }}>
              <h5 className="m-0" style={{ color: 'var(--accent-primary)' }}>{aktifHucre.gun} - {aktifHucre.ogun} Ekle</h5>

              <div className="d-flex align-items-center">
                {(() => {
                  const filtreliSablonlar = sablonlar.filter(s => s.kategori && s.kategori.ad === aktifHucre.ogun);
                  const gosterilecekSablonlar = filtreliSablonlar.length > 0 ? filtreliSablonlar : sablonlar;
                  const placeholder = filtreliSablonlar.length > 0
                    ? `${aktifHucre.ogun} şablonları (${filtreliSablonlar.length})...`
                    : sablonlar.length > 0 ? 'Tüm şablonlar (kategori eşleşmedi)...' : 'Şablon bulunamadı';
                  return (
                    <Form.Select
                      size="sm"
                      className="me-3"
                      style={{ minWidth: '260px', backgroundColor: 'var(--bg-primary)', color: 'var(--text-main)', borderColor: 'var(--border-color)' }}
                      onChange={(e) => {
                        if (e.target.value) handleSablonEkle(e.target.value, `${aktifHucre.gun}::${aktifHucre.ogun}`);
                        e.target.value = "";
                      }}
                    >
                      <option value="">{placeholder}</option>
                      {gosterilecekSablonlar.map(sablon => (
                        <option key={sablon.id} value={sablon.id}>{sablon.ad}{sablon.kategori ? ` (${sablon.kategori.ad})` : ''}</option>
                      ))}
                    </Form.Select>
                  );
                })()}
                <Button variant="outline-secondary" size="sm" onClick={() => setAktifHucre(null)}>Kapat</Button>
              </div>
            </div>
            <OzelOgunFormu 
              danisanId={randevu.danisan.id} 
              randevuId={randevuId} 
              onOgunEklendi={handleOgunEklendi} 
              onIptal={() => setAktifHucre(null)}
              sabitGun={aktifHucre.gun}
              sabitOgun={aktifHucre.ogun}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default RandevuDetay;